
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartData: { type: Object, required: true },
    options: { type: Object, required: true }
  },
  mounted() {
    this.addPlugin({
      id: "latarPutihLabTren",
      beforeDraw(chart) {
        const ctx = chart.ctx;
        ctx.save();
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
      }
    });
    this.addPlugin({
      id: "pitaRujukanLabTren",
      beforeDatasetsDraw(chart) {
        const pita = chart.options.rujukanLab;
        const area = chart.chartArea;
        const skala = chart.scales[Object.keys(chart.scales).find(k => k.indexOf("y") === 0) || ""];
        if (!pita || !area || !skala) return;
        const batas = (nilai: number) =>
          Math.min(area.bottom, Math.max(area.top, skala.getPixelForValue(nilai)));
        const ctx = chart.ctx;
        ctx.save();
        if (pita.low !== null && pita.high !== null) {
          const atas = batas(pita.high);
          const bawah = batas(pita.low);
          ctx.fillStyle = pita.isi;
          ctx.fillRect(area.left, atas, area.right - area.left, bawah - atas);
        }
        ctx.strokeStyle = pita.garis;
        ctx.lineWidth = 1;
        if (pita.low === null || pita.high === null) ctx.setLineDash([6, 4]);
        [pita.low, pita.high].forEach(nilai => {
          if (nilai === null) return;
          const y = Math.round(batas(nilai)) + 0.5;
          ctx.beginPath();
          ctx.moveTo(area.left, y);
          ctx.lineTo(area.right, y);
          ctx.stroke();
        });
        ctx.restore();
      }
    });
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData() {
      this.renderChart(this.chartData, this.options);
    },
    options() {
      this.renderChart(this.chartData, this.options);
    }
  }
};
